import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { DocumentoAPI } from '@/api/documento.api';
import { Documento } from '@/models/documento';

const api = new DocumentoAPI();

const list = (params: any): AxiosObservable<any> => {
  return api.list(params);
}

const show = (id: number): AxiosObservable<any> => {
  return api.show(id);
}

const showPublic = (secretToken: string, documentId: number): AxiosObservable<any> => {
  return api.showPublic(secretToken, documentId);
}

const download = (body: Documento): AxiosObservable<any> =>
  api.download(body);

const doDownloadFile = (data: any, file: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", file);
  document.body.appendChild(link);
  link.click();
};

const uploadFile = (orderId: number, documentId: number, body: any): AxiosObservable<any> => {
  return api.uploadFile(orderId, documentId, body);
}

const approve = (id: number): AxiosObservable<Documento> => {
  return api.approve(id);
}

const refuse = (id: number, reason: string): AxiosObservable<Documento> => {
  return api.refuse(id, reason);
}

const update = (id: number, body: any): AxiosObservable<Documento> => {
  return api.update(id, body);
}

const uploadFilePublic = (orderId: number, documentId: number, body: any): AxiosObservable<any> => {
  return api.uploadFilePublic(orderId, documentId, body);
}

export default {
  download,
  doDownloadFile,
  show,
  showPublic,
  list,
  uploadFile,
  uploadFilePublic,
  approve,
  refuse,
  update
}
